<template>
  <div
    class="vertical-layout h-100"
    :class="[layoutClasses, { 'navbar-hidden': isNavbarCollapsed || !shouldShowNavbar }]"
    :data-col="(isNavMenuHidden || !shouldShowNavbar) ? '1-column' : null"
  >
    <!-- Navbar -->
<b-navbar
  v-if="shouldShowNavbar"
  v-show="!isNavbarCollapsed"
  :toggleable="false"
  :variant="navbarBackgroundColor"
  class="header-navbar navbar navbar-shadow align-items-center"
  :class="[navbarTypeClass]"
  @toggle-navbar="toggleNavbar"
>
  <slot
    name="navbar"
    :toggleVerticalMenuActive="toggleVerticalMenuActive"
    :navbarBackgroundColor="navbarBackgroundColor"
    :navbarTypeClass="[...navbarTypeClass, 'header-navbar navbar navbar-shadow align-items-center']"
  >
    <app-navbar-vertical-layout
      :toggle-vertical-menu-active="toggleVerticalMenuActive"
      @toggle-navbar="$emit('toggle-navbar')"
    />
  </slot>
</b-navbar>

    <!--/ Navbar -->
 <div
    v-if="shouldShowNavbar"
    v-show="!isNavbarCollapsed"
    class="navbar-toggle-btn"
    @click="toggleNavbar"
  >
    <i :class="isNavbarCollapsed ? 'bx bx-chevron-down' : 'bx bx-chevron-up'"></i>
  </div>


      <!-- Vertical Nav Menu -->
  <vertical-nav-menu
    v-if="!isNavMenuHidden"
    :is-vertical-menu-active="isVerticalMenuActive"
    :toggle-vertical-menu-active="toggleVerticalMenuActive"
  >
    <template #header="slotProps">
            <slot
            name="vertical-menu-header"
            v-bind="slotProps"
          />
    </template>
  </vertical-nav-menu>
  <div
    v-show="isNavbarCollapsed"
    class="navbar-restore-btn"
    @click="toggleNavbar"
  >
     &#9776;
  </div>
    <!-- /Vertical Nav Menu -->

    <!-- Vertical Nav Menu Overlay -->
    <div
      class="sidenav-overlay"
      :class="overlayClasses"
      @click="isVerticalMenuActive = false"
    />
    <!-- /Vertical Nav Menu Overlay -->
    
    <!-- Content  "slide-fade"-->

    <!-- CONTENT TYPE: Left -->
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <component
        :is="layoutContentRenderer"
        :key="layoutContentRenderer === 'layout-content-renderer-left' ? $route.meta.navActiveLink || $route.name : null"
      >
        <template
          v-for="(index, name) in $scopedSlots"
          v-slot:[name]="data"
        >
          <slot
            :name="name"
            v-bind="data"
          />
        </template>
      </component>
    </transition>
    <!--/ Content -->

    <!-- Footer -->
    <!-- <footer class="footer footer-light" :class="[footerTypeClass]">
      <slot name="footer">
        <app-footer />
      </slot>
    </footer> -->
    <!-- /Footer -->

    <slot name="customizer" />
  </div>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import AppNavbarVerticalLayout from '@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue'
import AppFooter from '@core/layouts/components/AppFooter.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { BNavbar } from 'bootstrap-vue'
import LayoutContentRendererDefault from '@core/layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue'
import LayoutContentRendererLeft from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeft.vue'
import LayoutContentRendererLeftDetached from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeftDetached.vue'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import useVerticalLayout from './useVerticalLayout'
import mixinVerticalLayout from './mixinVerticalLayout'

export default {
  components: {
    // AppBreadcrumb,
    AppNavbarVerticalLayout,
    AppFooter,
    VerticalNavMenu,
    BNavbar,
    LayoutContentRendererLeftDetached,
    LayoutContentRendererLeft,
    LayoutContentRendererDefault,
  },
  mixins: [mixinVerticalLayout],
  computed: {
    shouldShowNavbar() {
    return !this.$route.meta.hideNavbar;
  },
    layoutContentRenderer() {
      const rendererType = this.$route.meta.contentRenderer
      if (rendererType === 'sidebar-left') return 'layout-content-renderer-left'
      if (rendererType === 'sidebar-left-detached') return 'layout-content-renderer-left-detached'
      return 'layout-content-renderer-default'
    },
  },
  setup() {
    const {
      routerTransition, navbarBackgroundColor, navbarType, footerType, isNavMenuHidden,
    } = useAppConfig()

    const {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      layoutClasses,
      overlayClasses,
      resizeHandler,
      navbarTypeClass,
      footerTypeClass,
    } = useVerticalLayout(navbarType, footerType)

    const isNavbarCollapsed = ref(false)
    const toggleNavbar = () => {
      isNavbarCollapsed.value = !isNavbarCollapsed.value
      document.body.classList.toggle('navbar-hidden', isNavbarCollapsed.value)
    }

    // Resize handler
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler)
    })

    return {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      overlayClasses,
      layoutClasses,
      navbarTypeClass,
      footerTypeClass,

      // App Config
      routerTransition,
      navbarBackgroundColor,
      isNavMenuHidden,
      isNavbarCollapsed,
      toggleNavbar,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";
</style>
